function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("In digital marketing, the funnel analysis starts by understanding the traffic.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox tracks and reports the source of each anonymous of user web visit, so you could understand exactly how a conversion comes to your website. WhiteBox is able to link user browsing history retrospectively, including multi-channel and multi-device with other data source, like phone calls, sales data, ect. Among many, you could easily get to answer these questions:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("What is the optimal path to get users into contacting me?")]),_vm._v(" "),_c('li',[_vm._v("How many times I need to get users on my website to get a conversion?")]),_vm._v(" "),_c('li',[_vm._v("What is my revenue from Google, Facebook, Instagram, Twitter, MailChimp, Messenger, SMS, Viber or other channels?")]),_vm._v(" "),_c('li',[_vm._v("What combination of traffic channels delivers optimal results?")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/web","interaction":"web","title":"(Website Traffic)|analysis","image":"/img/interactions/6.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }